import React from 'react';
import { Navigate } from 'react-router-dom';
import Auth from '../../services/Auth';
import AuthService from 'Api/Auth';
import HasPermission from "Components/Router/Permission";

const PrivateRoute = ({ children, hideFor, showFor, requireAfasAccess = false }) => {
    const isLoggedIn = Auth.isLoggedIn();

    if (!isLoggedIn) {
        return <Navigate to="/login" replace />;
    }

    const roles = AuthService.getUserRoles() || [];
    if (requireAfasAccess && !roles.includes(AuthService.AFAS_ROLE)) {
        return <Navigate to="/do-not-have-permmison" replace />;
    }

    return (
        <HasPermission
            hideFor={hideFor}
            showError={true}
            showFor={showFor}
        >{children}
        </HasPermission>);

}

export default PrivateRoute;
